import { useState, useEffect } from "react";

/** Breakpoint mobile — aligné sur `md` de Tailwind. */
export const MOBILE_MAX_WIDTH = 767;
const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

/**
 * `true` tant que le viewport est sous le breakpoint mobile.
 *
 * On s'appuie sur matchMedia plutôt que sur `window.innerWidth` + l'évènement
 * `resize` : les navigateurs in-app (Instagram, Facebook…) ne déclenchent pas
 * toujours `resize` quand leurs barres système se replient, ce qui figeait le
 * dashboard sur la grille desktop 6 colonnes compressée dans ~370px.
 * matchMedia notifie aussi les changements d'orientation.
 */
export default function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(MOBILE_QUERY);
    // Re-sync au montage : la valeur initiale peut dater d'un rendu SSR ou d'un
    // premier paint où le viewport in-app n'était pas encore stabilisé.
    setIsMobile(mql.matches);

    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
